/**
 * Pokédex « jouable » — aligné client `MAIN_POKEDEX` / `getPokedexByGen` / complétion de région.
 * Exclut les formes Gigamax (`*-gmax`). Les Méga comptent comme entrées distinctes.
 *
 * Totaux dérivés de `client/app/data/pokedex.ts` (filtre `!slug.endsWith('-gmax')`).
 */
export function isMainPokedexSlug(slug: string): boolean {
  return !slug.endsWith('-gmax')
}

/** Nombre d'entrées par génération (1–9) dans le Pokédex principal. */
export const MAIN_POKEDEX_TOTAL_BY_GEN: Readonly<Record<number, number>> = {
  1: 172,
  2: 109,
  3: 157,
  4: 118,
  5: 164,
  6: 84,
  7: 111,
  8: 132,
  9: 128,
}

export function getMainPokedexTotalForGen(gen: number): number {
  return MAIN_POKEDEX_TOTAL_BY_GEN[gen] ?? 0
}
